import React from 'react';
import Card from '../../ui/Card';
const CrossFunctionalHeatMap: React.FC = () => {
  const regions = ['North', 'West', 'South', 'East'];
  const metrics = [{
    name: 'Sales (₹Cr)',
    key: 'sales'
  }, {
    name: 'Margin %',
    key: 'margin'
  }, {
    name: 'Service TAT',
    key: 'service'
  }, {
    name: 'Inventory Days',
    key: 'inventory'
  }, {
    name: 'Receivables',
    key: 'receivables'
  }];
  const data = {
    North: {
      sales: 2850,
      margin: 18.2,
      service: 2.8,
      inventory: 42,
      receivables: 55
    },
    West: {
      sales: 3200,
      margin: 19.1,
      service: 3.1,
      inventory: 38,
      receivables: 52
    },
    South: {
      sales: 2100,
      margin: 17.5,
      service: 3.5,
      inventory: 45,
      receivables: 58
    },
    East: {
      sales: 1100,
      margin: 16.8,
      service: 4.2,
      inventory: 48,
      receivables: 62
    }
  };
  const getColorIntensity = (value: number, metric: string) => {
    let normalized = 0;
    switch (metric) {
      case 'sales':
        normalized = (value - 1000) / (3200 - 1000);
        break;
      case 'margin':
        normalized = (value - 16) / (20 - 16);
        break;
      case 'service':
        normalized = 1 - (value - 2.5) / (4.5 - 2.5);
        break;
      case 'inventory':
        normalized = 1 - (value - 35) / (50 - 35);
        break;
      case 'receivables':
        normalized = 1 - (value - 50) / (65 - 50);
        break;
    }
    normalized = Math.max(0, Math.min(1, normalized));
    if (normalized >= 0.8) return 'bg-green-600';
    if (normalized >= 0.6) return 'bg-green-400';
    if (normalized >= 0.4) return 'bg-yellow-400';
    if (normalized >= 0.2) return 'bg-orange-400';
    return 'bg-red-400';
  };
  return <Card className="p-6 bg-gradient-to-br from-purple-50 to-white" data-id="element-2774">
      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2775">
        Cross-Functional Performance Heat Map
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-2776">
        Regional performance across key metrics
      </p>
      <div className="overflow-x-auto" data-id="element-2777">
        <table className="w-full" data-id="element-2778">
          <thead data-id="element-2779">
            <tr data-id="element-2780">
              <th className="text-left py-2 px-3 text-xs font-semibold text-gray-700" data-id="element-2781">
                Region
              </th>
              {metrics.map((metric, index) => <th key={index} className="text-center py-2 px-3 text-xs font-semibold text-gray-700" data-id="element-2782">
                  {metric.name}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-2783">
            {regions.map((region, rowIndex) => <tr key={rowIndex} className="border-t border-gray-200" data-id="element-2784">
                <td className="py-3 px-3 text-sm font-semibold text-gray-800" data-id="element-2785">
                  {region}
                </td>
                {metrics.map((metric, colIndex) => {
              const value = data[region][metric.key];
              return <td key={colIndex} className="py-3 px-3 text-center" data-id="element-2786">
                      <div className={`${getColorIntensity(value, metric.key)} text-white font-semibold text-sm py-2 px-3 rounded`} data-id="element-2787">
                        {metric.key === 'sales' && `₹${value}`}
                        {metric.key === 'margin' && `${value}%`}
                        {metric.key === 'service' && `${value}d`}
                        {metric.key === 'inventory' && `${value}d`}
                        {metric.key === 'receivables' && `${value}d`}
                      </div>
                    </td>;
            })}
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 flex items-center justify-end space-x-2 text-xs" data-id="element-2788">
        <span className="text-gray-600" data-id="element-2789">Performance:</span>
        <div className="flex items-center space-x-1" data-id="element-2790">
          <div className="w-4 h-4 bg-green-600 rounded" data-id="element-2791" />
          <span className="text-gray-600" data-id="element-2792">High</span>
        </div>
        <div className="flex items-center space-x-1" data-id="element-2793">
          <div className="w-4 h-4 bg-yellow-400 rounded" data-id="element-2794" />
          <span className="text-gray-600" data-id="element-2795">Medium</span>
        </div>
        <div className="flex items-center space-x-1" data-id="element-2796">
          <div className="w-4 h-4 bg-red-400 rounded" data-id="element-2797" />
          <span className="text-gray-600" data-id="element-2798">Low</span>
        </div>
      </div>
    </Card>;
};
export default CrossFunctionalHeatMap;